/**
 * Emplacements figés assistant : 2 STL (upper/lower) + 10 photos (photoKey).
 */

import { getRequiredClinicalPhotoKeys } from '../case-dentist/scanUploadConfig';
import { supabase } from './supabase';

export function isUpperStlPath(filePath) {
  return String(filePath || '').includes('-upper.stl');
}

export function isLowerStlPath(filePath) {
  return String(filePath || '').includes('-lower.stl');
}

/**
 * @param {Array<{ category?: string, photoKey?: string }>} files
 */
export function buildUploadedPhotosByKey(files = []) {
  const map = {};
  for (const f of files) {
    if (f.category === 'photos' && f.photoKey) {
      map[f.photoKey] = f;
    }
  }
  return map;
}

/**
 * @param {Array<{ category?: string, filePath?: string }>} files
 * @returns {{ upper: object|null, lower: object|null }}
 */
export function buildUploadedStlScans(files = []) {
  let upper = null;
  let lower = null;
  for (const f of files) {
    if (f.category !== 'scans') continue;
    const path = f.filePath || '';
    if (isUpperStlPath(path)) upper = f;
    else if (isLowerStlPath(path)) lower = f;
  }
  return { upper, lower };
}

/**
 * Fichiers des emplacements figés pour téléchargement groupé.
 * @param {Array} files
 * @param {'all'|'scans'|'photos'} mode
 */
export function listClinicalSlotFiles(files = [], mode = 'all') {
  const { upper, lower } = buildUploadedStlScans(files);
  const photosByKey = buildUploadedPhotosByKey(files);
  const scans = [upper, lower].filter(Boolean);
  const photos = getRequiredClinicalPhotoKeys()
    .map((key) => photosByKey[key])
    .filter(Boolean);

  if (mode === 'scans') return scans;
  if (mode === 'photos') return photos;
  return [...scans, ...photos];
}

/**
 * Fichiers hors emplacements figés (documents, legacy).
 * @param {Array} files
 */
export function listNonSlotFiles(files = []) {
  const photosByKey = buildUploadedPhotosByKey(files);
  const { upper, lower } = buildUploadedStlScans(files);
  const slotIds = new Set(
    [
      upper?.id,
      lower?.id,
      ...Object.values(photosByKey).map((p) => p?.id),
    ].filter(Boolean),
  );

  return files.filter((f) => {
    if (slotIds.has(f.id)) return false;
    if (f.category === 'documents' || f.category === 'reports') return true;
    if (f.category === 'photos' && !f.photoKey) return true;
    if (f.category === 'scans') return true;
    return false;
  });
}

/**
 * @param {string} photoId
 */
export async function softDeleteCasePhoto(photoId) {
  if (!photoId) return;
  const { error } = await supabase
    .from('case_photos')
    .update({ is_active: false })
    .eq('id', photoId);
  if (error) throw error;
}

/**
 * @param {string} scanId
 */
export async function softDeleteCaseScan(scanId) {
  if (!scanId) return;
  const { error } = await supabase
    .from('case_scans')
    .update({ is_active: false })
    .eq('id', scanId);
  if (error) throw error;
}
